"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var IframeUtility_1 = __importDefault(require("./IframeUtility"));
/**
 * IframeVisibleArea.
 */
var IframeVisibleArea = /** @class */ (function () {
    function IframeVisibleArea() {
    }
    /**
     * Returns bottom, top, left and right.
     *
     * @param overflow Overflow.
     * @returns Position.
     */
    IframeVisibleArea.getArea = function (overflow) {
        if (!this.isInsideIframe) {
            throw 'IframeVisibleArea only works when it is called from inside an iframe';
        }
        // TODO: Remove header height as we can't calculate it anymore after we removed uiPlatform from settings.
        var headerHeight = 0;
        var pageHeight = document.body.offsetHeight;
        var screenHeight = window.parent.innerHeight;
        var frameRect = window.frameElement.getBoundingClientRect();
        var positionBottom = pageHeight + frameRect.top - screenHeight;
        var position = {
            top: frameRect.top < headerHeight ? -1 * frameRect.top + headerHeight : 0,
            bottom: positionBottom > 0 ? positionBottom : 0
        };
        if (overflow) {
            var pageBodyHeight = 320;
            position.top = frameRect.top < headerHeight ? -1 * frameRect.top + headerHeight : 0;
            position.bottom = positionBottom > 0 ? positionBottom : 0;
            var topOffset = pageHeight - position.bottom - position.top;
            position.top -= topOffset < pageBodyHeight ? pageBodyHeight - topOffset : 0;
            position.top = position.top > 0 ? position.top : 0;
            var bottomOffset = pageHeight - position.bottom - position.top;
            position.bottom -= bottomOffset < pageBodyHeight ? pageBodyHeight - bottomOffset : 0;
            position.bottom = position.bottom > 0 ? position.bottom : 0;
            return position;
        }
        else {
            return position;
        }
    };
    IframeVisibleArea.isInsideIframe = IframeUtility_1.default.isInsideIframe();
    return IframeVisibleArea;
}());
exports.default = IframeVisibleArea;
//# sourceMappingURL=IframeVisibleArea.js.map